import React from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useAnnouncement } from '@context/AnnouncementContext';
import AnnouncementMarkdown from './AnnouncementMarkdown';
import { muiSeverity } from './severity';

const SEVERITY_LABEL = {
  info: 'Información',
  warning: 'Aviso importante',
  critical: 'Aviso urgente',
};

/** Modal con el comunicado completo. Se abre al entrar y desde el botón «Ver» del banner. */
const AnnouncementModal = () => {
  const { announcement, isModalOpen, dismiss } = useAnnouncement();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (!announcement) return null;

  const severity = muiSeverity(announcement.severity);

  return (
    <Dialog
      open={isModalOpen}
      onClose={dismiss}
      maxWidth="sm"
      fullWidth
      fullScreen={isMobile}
      // El AppBar de Navbar no lleva .mui-fixed, así que el scroll-lock de MUI
      // lo desplazaría ~15px al abrir el modal.
      disableScrollLock
      aria-labelledby="announcement-modal-title"
    >
      <DialogTitle id="announcement-modal-title" sx={{ fontWeight: 700, color: '#002642', pr: 6 }}>
        {announcement.title}
      </DialogTitle>
      <DialogContent dividers>
        <Alert severity={severity} sx={{ mb: 2 }}>
          {SEVERITY_LABEL[announcement.severity] || SEVERITY_LABEL.info}
        </Alert>
        <AnnouncementMarkdown>{announcement.body}</AnnouncementMarkdown>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={dismiss} variant="contained" color={severity === 'info' ? 'primary' : severity}>
          Entendido
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AnnouncementModal;
